import { ToastService } from "@shared/lib/services";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { BRIEF_CAMPAIGN_INFLUENCER_QUERY_KEY } from "../contsants";
import { CampaignService } from "../services/Campaign.service";

export function useGetBriefCampaignInfluner({
  campaignInfluencerId,
  briefInfluencerId,
  enabled,
  staleTime
}: {
  campaignInfluencerId?: string;
  briefInfluencerId?: string;
  enabled?: boolean;
  staleTime?: number;
}) {
  const { data, isLoading, isFetching, isError, error, refetch } = useQuery({
    queryKey: [
      ...BRIEF_CAMPAIGN_INFLUENCER_QUERY_KEY(
        campaignInfluencerId,
        briefInfluencerId
      ),
    ],
    queryFn: () =>
      CampaignService.getCampaignInfluencer(
        campaignInfluencerId,
        briefInfluencerId
      ),
    enabled: enabled,
    staleTime: staleTime
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    briefInfluencer: data?.data?.briefInfluencer,
    campaignInfluencer: data?.data?.campaignInfluencer,
    finalBrandCost: data?.data?.finalBrandCost ?? 0,
    finalInfluencerCost: data?.data?.finalInfluencerCost ?? 0,
    isLoading,
    isFetching,
    isError,
    refetch,
  };
}
